import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil, pick } from 'lodash';
import { PayerDropdown } from './PayerDropdown';

const CountryDropdown = ({ countries, selectedCountry, setSelectedCountry, disabled = false }) => {
  const { t } = useTranslation();

  const allCountries = t('enums.countryCode.values', { returnObjects: true });

  return (
    <PayerDropdown
      items={!isNil(countries) ? pick(allCountries, countries) : allCountries}
      noItemsText={t('enums.countryCode.noCountriesConfigured')}
      selectedItem={selectedCountry}
      noSelectedItemText={t('enums.countryCode.selectCountry')}
      onItemSelect={setSelectedCountry}
      disabled={disabled}
    />
  );
};

CountryDropdown.propTypes = {
  countries: PropTypes.array,
  selectedCountry: PropTypes.string,
  setSelectedCountry: PropTypes.func,
  disabled: PropTypes.bool,
};

export { CountryDropdown };
